Namespace 'Customer.Views.Activity'

class Customer.Views.Activity.SubtypeChildrenView extends Backbone.View
  className: 'subtype-children-view'

  initialize: ({@subtypes, @id, @selectedSubtypes}) ->
    @subtypeCheckboxViews = @subtypes.map (subtype) =>
      new Customer.Views.Activity.SubtypeCheckboxView
        subtype: subtype
        isSelected: @selectedSubtypes.includes(subtype)
    @subtypeCheckboxViews.forEach (checkboxView) => @listenTo(checkboxView, 'checkbok:change', @onCheckboxChange)

  render: ->
    @subtypeCheckboxViews.forEach (checkboxView) => @$el.append checkboxView.render().el
    @

  areAllChecked: ->
    _.all(@subtypeCheckboxViews, (view) -> view.isChecked())

  onCheckboxChange: ->
    @trigger('subtype:checkbox:change')
